import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=6fb20d62"
import script from "./transactionDetail.vue?vue&type=script&lang=js"
export * from "./transactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports